import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
    HttpClient,
    HttpHeaders,
    HttpErrorResponse
} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoginData } from 'src/app/core/models/customer-details';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({ providedIn: 'root' })
export class HttpService {

    constructor(private http: HttpClient, public modalService: NgbModal, private router: Router) { }

    get(url, body) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                deliteId: localStorage.getItem('userId') || ''
            }),
            body
        };
        const observable = new Observable(observer => {
            this.http.get(url, httpOptions).pipe(map((data: any) => {
                observer.next(data);
            }, error => {
                observer.error(error);
            }));
        });
        return observable;
    }

    post(url, reqBody) {
        
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': environment.appRegistry.authId
            })
        };
        const observable = new Observable(observer => {

            this.http.post(url, JSON.stringify(reqBody), httpOptions).subscribe((data) => {
                observer.next(data);
            }, error => {
                observer.error(error);
            });
        });
        return observable;
    }

    putWithRefreshToken(url, reqBody) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                refreshToken: localStorage.getItem('refreshToken') || '',
                deliteId: localStorage.getItem('userId') || ''
            })
        };
        const observable = new Observable(observer => {

            this.http.put(url, JSON.stringify(reqBody), httpOptions).subscribe((data) => {
                observer.next(data);
            }, error => {
                observer.error(error);
            });
        });
        return observable;
    }

    postWithRefershToken(url, reqBody) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                refreshToken: localStorage.getItem('refreshToken') || '',
                deliteId: localStorage.getItem('userId') || '',
                'Authorization': environment.appRegistry.authId
            })
        };

        const observable = new Observable(observer => {
            this.http.post(url, JSON.stringify(reqBody), httpOptions).subscribe((data) => {
                observer.next(data);
            }, error => {
                observer.error(error);
            });
        });
        return observable;
    }

    put(url, reqBody) {
        
        const httpOptions = {
            headers: new HttpHeaders({
                // deliteId: localStorage.getItem('userId'),
                Authorization: environment.appRegistry.authId
                // refreshToken: localStorage.getItem('refreshToken')
            })
        };
        const observable = new Observable(observer => {
            this.http.put(url, JSON.stringify(reqBody), httpOptions).subscribe((data) => {
                observer.next(data);
            }, error => {
                observer.error(error);
            });
        });
        return observable;
    }

    putWithRefershToken(url, reqBody) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                refreshToken: localStorage.getItem('refreshToken') || '',
                deliteId: localStorage.getItem('userId') || ''
            })
        };
        const observable = new Observable(observer => {
            this.http.put(url, JSON.stringify(reqBody), httpOptions).subscribe((data) => {
                observer.next(data);
            }, error => {
                observer.error(error);
            });
        });
        return observable;
    }

}
